module.exports = __webpack_public_path__ + "img/ausstellung1.d4c2fc87.jpg";